export enum CountryCode {
  AE = '+971',
  IN = '+91',
  QA = '+974',
  SA = '+966',
  BH = '+973',
  KW = '+965',
  OM = '+968',
  US = '+1',
}

export enum CountryGroup {
  AE = 'ae',
  IN = 'in',
  QA = 'qa',
  SA = 'sa',
  BH = 'bh',
  KW = 'kw',
  OM = 'om',
  US = 'us',
}

export enum AuthHelpCameFrom {
  LANDING = 'landing',
  LOGIN = 'login',
  MARKETING = 'marketing',
}

export enum CameUsing {
  OTHER_COURSE = 'other_course',
  HEADER = 'header',
}

export enum APP_METHODS {
  OPEN_AUTH_SCREEN = 'openAuthScreen',
  HANDLE_VERIFIED_USER = 'handleVerifiedUser',
  INITIATE_OTPLESS_TRUECALLER = 'initiateOtplessTruecaller',
  SAVE_USER = 'saveUser',
  DOWNLOAD_FILE = 'downloadFile',
  SHARE_FILE = 'shareFile',
  HANDLE_MY_PURCHASE_CLICK = 'handleMyPurchaseClick',
  HANDLE_MENTOR_CLICK = 'handleMentorClick',
  HANDLE_CONTINUE_LEARNING = 'handleContinueLearning',
  CLOSE_WEB_VIEW = 'closeWebView',
  EXIT_SCREEN = 'exitScreen',
}

export enum APP_REDIRECTION_SCREENS {
  PAYMENT = 'payment',
  ORDER_SUMMARY = 'order_summary',
}

export enum CjrWidgetsId {
  LANDING_PAGE_HERO_SECTION = 'Landing.Page.Hero.Section',
}

export enum MoengageUserAttributes {
  SELECTED_COHORT = 'selected_cohort',
  USER_TYPE = 'user_type',
  USER_GRADE = 'user_grade',
  PREFERRED_LANGUAGE = 'preferred_language',
  GCLID = 'gclid',
  FBCLID = 'fbclid',
}

export enum RATE_LIMIT {
  START_TIME = 'RATE_LIMIT_RETRY_START',
}

export enum StripeUiMode {
  EMBEDDED = 'embedded',
}

export enum HeaderLinkTitle {
  ACTIVITY_KITS = 'Activity Kits',
}

export enum HomePageSectionId {
  POST_PURCHASE_SCHEDULES = 'post-purchase-schedules',
  HOME_PAGE_SCHEDULES_END = 'learn-play',
  HERO_SECTION = 'hero-section',
  OPEN_SESSION = 'open-session',
  BRAIN_BYTES = 'brainBytes',
  PRACTICE = 'practice',
  ANIMATED = 'animated',
  COHORT_SWITCHER = 'cohort-switcher',
  REFERRAL_CARD = 'referral-card',
}

export enum PAGE_SOURCE {
  EXPLORE = 'explore',
  HOME = 'home',
}

export enum VideoStatus {
  VIDEO_COMPLETED = 'VIDEO_COMPLETED',
  videoEnded = 'videoEnded',
  locked = 'locked',
}
